const stickyElements = {
	announcement: {
		selector: '.shopify-section--announcement-bar',
		variable: '--announcement-bar-height',
	},
	campaignCountdown: {
		selector: '.top-bar-countdown.campaign',
		variable: '--countdown-bar-height',
	},
	dailyCountdown: {
		selector: '.top-bar-countdown.daily',
		variable: '--daily-countdown-bar-height',
	},
};

const getElementHeight = (selector) => {
	const elements = document.querySelectorAll(selector);
	const heights = Array.from(elements).map((element) => element.getBoundingClientRect().height);
	return Math.round(Math.max(0, ...heights));
};

const updateStickyHeights = () => {
	Object.values(stickyElements).forEach(({ selector, variable }) => {
		const height = getElementHeight(selector);
		document.documentElement.style.setProperty(variable, `${height}px`);
	});
};

const observer = new ResizeObserver(() => {
	requestAnimationFrame(updateStickyHeights);
});

Object.values(stickyElements).forEach(({ selector }) => {
	document.querySelectorAll(selector).forEach((element) => observer.observe(element));
});

window.addEventListener('resize', () => {
	requestAnimationFrame(updateStickyHeights);
});

document.addEventListener('DOMContentLoaded', () => {
	requestAnimationFrame(updateStickyHeights);
});
